import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { listLanguages, Languages } from "src/models/language.model";
import { Subscription } from "rxjs";
import { UtilService } from "src/app/services/util.service";
import { CrudService } from "src/app/services/crud.service";
import { RestaurantService } from "src/app/services/restaurant.service";

//import * as moment from "moment";
import moment from "moment-timezone";
import { ThemePalette } from "@angular/material/core";
import { DatePipe } from "@angular/common";

const today = moment().endOf("day");

import { IonModal, Platform } from "@ionic/angular";
import { CalendarService } from "src/app/services/calendar.service";
import { AuthService } from "src/app/services/auth.service";
import { UserType } from "src/models/user.model";
import { KitchenTypesComponents } from "src/app/components/kitchen-types/kitchen-types.component";
import { listServices } from "src/models/services.model";
import { NgxCaptureService } from "ngx-capture";
import { tap } from "rxjs/operators";

@Component({
    selector: "app-restaurant-booking",
    templateUrl: "./restaurant.booking.html",
    styleUrls: ["./restaraunt.booking.scss"],
    providers: [DatePipe],
    standalone: false
})
export class RestaurantBookingComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
